import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function AppSidebar() {
    const { hasPermission, user } = useAuth();

    useEffect(() => {
        // Pending requisitions logic removed as per stock-only consolidation
    }, []);

    const menuItems = [
        // { label: 'Obras', path: '/obras', icon: 'ri-building-2-fill', visible: hasPermission('obras', 'ver') },
        { label: 'PCM', path: '/pcm/dashboard', icon: 'ri-dashboard-3-fill', visible: hasPermission('pcm', 'ver') },
        { label: 'Agenda', path: '/agenda', icon: 'ri-calendar-todo-fill', visible: hasPermission('pcm', 'ver') },
        { label: 'Técnico', path: '/pcm/tecnico', icon: 'ri-tools-fill', visible: hasPermission('pcm', 'ver') && (user?.cargo_nome === 'Técnico' || user?.cargo_nome === 'Admin') },
        { label: 'Operador', path: '/pcm/operador/scan', icon: 'ri-barcode-box-fill', visible: hasPermission('pcm', 'ver') && (user?.cargo_nome === 'Operador' || user?.cargo_nome === 'Admin') },
        { label: 'Estoque', path: '/estoque', icon: 'ri-archive-fill', visible: hasPermission('suprimentos', 'ver') },
        { label: 'Financeiro', path: '/financeiro', icon: 'ri-money-dollar-circle-fill', visible: hasPermission('financeiro', 'ver') },
        // { label: 'Equipamentos', path: '/equipamentos', icon: 'ri-hammer-fill', visible: hasPermission('equipamentos', 'ver') },
        { label: 'Configurações', path: '/configuracoes', icon: 'ri-settings-4-fill', visible: hasPermission('configuracoes', 'ver') },
    ];

    const visibleItems = menuItems.filter(item => item.visible);

    return (
        <aside className="w-20 bg-white border-r border-gray-200 flex flex-col items-center py-4 z-40 h-full">
            <nav className="flex-1 flex flex-col space-y-4 w-full px-2">
                {visibleItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `group relative flex items-center justify-center w-full aspect-square rounded-xl transition-all duration-200 ${isActive
                                ? 'bg-teal-50 text-teal-600 shadow-sm'
                                : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
                            }`
                        }
                    >
                        <i className={`${item.icon} text-2xl`}></i>

                        {/* Tooltip */}
                        <div className="absolute left-full ml-3 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50">
                            {item.label}
                        </div>

                        {/* Badge removed with Suprimentos */}
                    </NavLink>
                ))}
            </nav>
        </aside>
    );
}
